/** Map API auth error payloads to user-facing messages. */
export const getAuthErrorMessage = (err, fallback = 'Something went wrong. Please try again.') => {
  const data = err?.response?.data;
  if (!data) return fallback;
  if (data.message) return data.message;
  const codeMessages = {
    weak_password: 'Password does not meet security requirements.',
    invalid_credentials: 'Invalid email or password.',
    account_locked: 'Account is temporarily locked. Try again later or reset your password.',
    rate_limited: 'Too many attempts. Please wait and try again.',
    invalid_or_expired_token: 'This reset code is invalid or has expired. Request a new one.',
    password_change_required: 'You must change your password before continuing.',
    invalid_old_password: 'Current password is incorrect.',
    unauthorized: 'Please sign in again.',
    forbidden: 'You do not have permission to perform this action.',
  };
  if (data.code && codeMessages[data.code]) return codeMessages[data.code];
  return fallback;
};

export const PASSWORD_HINT = 'Min 8 characters with uppercase, lowercase, a number, and a special character.';
